export default __webpack_public_path__ + "static/media/socks.e6b0bda3.svg";